import loadable, { LoadableComponent } from '@loadable/component';
import { QueryLoadingAbsolute } from 'modules/common/components/QueryLoading/QueryLoading';
import { RouteConfiguration } from 'modules/common/types/RouteConfiguration';
import { Route } from 'react-router-dom';

const PATH_INFEX = '/index';

export const MarketRoutesConfig: { [key: string]: RouteConfiguration } = {
  INDEX: {
    path: PATH_INFEX,
    generatePath: () => PATH_INFEX,
  },
};

const LoadableContainer: LoadableComponent<any> = loadable(
  async () =>
    import('./screens').then(module => module.Index),
  {
    fallback: <QueryLoadingAbsolute />,
  },
);

export function MarketRoutes() {
  return (
    <Route
      path={MarketRoutesConfig.INDEX.path}
      exact={true}
      component={LoadableContainer}
    />
  );
}
